import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useMe () {
  return useQuery('me', async () => {
    const response = await axios.get(`${getApiServer()}/users/me`, { withCredentials: true })
    return response.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}